import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { HAMMER_LOADER } from '@angular/platform-browser';
import { HTTP_INTERCEPTOR_PROVIDERS } from './interceptors';
import { CrmErrorHandler } from './crm-error-handler';
import { USEDESK_MESSENGER_PROVIDER } from './services/usedesk.service';
import { environment } from '@environment';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { WfmOperatorPollingService } from './services/wfm-operator-polling.service';
import { EventBusListenerService } from './services/event-bus-listener.service';

let devModeProviders = [];
if (!environment.production) {
  devModeProviders = [
    {
      provide: HAMMER_LOADER,
      useValue: () => new Promise(() => {}),
    },
  ];
}

@NgModule({
  imports: [TranslocoModule],
  providers: [
    ...HTTP_INTERCEPTOR_PROVIDERS,
    ...devModeProviders,
    USEDESK_MESSENGER_PROVIDER,
    { provide: ErrorHandler, useClass: CrmErrorHandler },
  ],
})
export class CrmCoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CrmCoreModule,
    translocoService: TranslocoService,
    polling: WfmOperatorPollingService,
    listener: EventBusListenerService,
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
    registerTranslationsManually('crmCoreModule', translocoService, import.meta.webpackContext!('./translation'));
    listener.init();
    polling.init();
  }
}
